import * as React from "react";
import { SlideSearch24Filled, SlideSearch24Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const DareApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "Dare" */ "./DareApp");
    return { default: namedExport.DareApp };
});

export const Dare: TeamAppConfig = {
    title: "DARE",
    regularIcon: SlideSearch24Regular,
    filledIcon: SlideSearch24Filled,
    description:
        "Detect Alert and Recovery Engine — manage DARE configuration entities (endpoints, rules, recovery plugins, teams) " +
        "and inspect service-quality alert analytics, scoped by environment.",
    team: "DAREAdmin",
    publicId: "DETECTALERTANDRECOVERYENGINE\\Triage",
    owner: "DAREAdmin@microsoft.com",
    role: "*",
    tags: ["DareV3", "Config", "Rules", "Endpoints", "Anomalies", "Recoveries"],
    app: DareApp,
    path: "/Dare"
};
